'use strict';

import React, { PropTypes } from 'react';
import PureRenderMixin from '../mixins/PureRenderMixin';
import Icon from '../atoms/Icon';

var StampRichThumbnail = React.createClass({
  mixins: [PureRenderMixin],

  propTypes: {
    counts: PropTypes.object.isRequired,
    iconSize: PropTypes.oneOf(['xxsmall', 'xsmall']).isRequired
  },

  render() {
    var { counts } = this.props;

    return (
      <ul className='StampItem-contents'>
        {counts.audios > 0 &&
          <li className='StampItem-contentItem StampItem-contentItem--audio'>
            <Icon name='audio'
                  size={this.props.iconSize}
                  mode='stroke' />
          </li>
        }
        {counts.videos > 0 &&
          <li className='StampItem-contentItem StampItem-contentItem--video'>
            <Icon name='video'
                  size={this.props.iconSize}
                  mode='stroke' />
          </li>
        }
      </ul>
    );
  }
});

export default StampRichThumbnail;


/** WEBPACK FOOTER **
 ** ./molecules/StampRichThumbnail.jsx
 **/